import * as Period from '../../../../constants/Period';
var TENNIS_PERIOD_MAP = {};
TENNIS_PERIOD_MAP[600] = Period.NOT_STARTED;
TENNIS_PERIOD_MAP[601] = Period.FIRST;
TENNIS_PERIOD_MAP[602] = Period.SECOND;
TENNIS_PERIOD_MAP[603] = Period.THIRD;
TENNIS_PERIOD_MAP[604] = Period.FOURTH;
TENNIS_PERIOD_MAP[605] = Period.FIFTH;
TENNIS_PERIOD_MAP[606] = Period.FINISHED;
export default TENNIS_PERIOD_MAP;



// WEBPACK FOOTER //
// ./src/components/grid/sportGlossary/Tennis/PeriodMap.js